import { render, staticRenderFns } from "./BonusRequestHistory.vue?vue&type=template&id=b6a8e9a8&scoped=true"
import script from "./BonusRequestHistory.vue?vue&type=script&lang=js"
export * from "./BonusRequestHistory.vue?vue&type=script&lang=js"
import style0 from "./BonusRequestHistory.vue?vue&type=style&index=0&id=b6a8e9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a8e9a8",
  null
  
)

export default component.exports